import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './CountrySelector.css';

const CountrySelector = ({ onCountrySelect, onClose }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({ code: 'IN', name: 'India', flag: 'https://flagcdn.com/w40/in.png' });
  const [selectedLanguage, setSelectedLanguage] = useState('EN');
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const buttonRef = React.useRef(null);

  const countries = [
    { code: 'AT', name: 'Austria', flag: 'https://flagcdn.com/w40/at.png' },
    { code: 'AZ', name: 'Azerbaijan', flag: 'https://flagcdn.com/w40/az.png' },
    { code: 'BH', name: 'Bahrain', flag: 'https://flagcdn.com/w40/bh.png' },
    { code: 'BD', name: 'Bangladesh', flag: 'https://flagcdn.com/w40/bd.png' },
    { code: 'BA', name: 'Bosnia & Herzegovina', flag: 'https://flagcdn.com/w40/ba.png' },
    { code: 'CZ', name: 'Czech Republic', flag: 'https://flagcdn.com/w40/cz.png' },
    { code: 'EG', name: 'Egypt', flag: 'https://flagcdn.com/w40/eg.png' },
    { code: 'ET', name: 'Ethiopia', flag: 'https://flagcdn.com/w40/et.png' },
    { code: 'GE', name: 'Georgia', flag: 'https://flagcdn.com/w40/ge.png' },
    { code: 'IN', name: 'India', flag: 'https://flagcdn.com/w40/in.png' },
    { code: 'IR', name: 'Iran', flag: 'https://flagcdn.com/w40/ir.png' },
    { code: 'IQ', name: 'Iraq', flag: 'https://flagcdn.com/w40/iq.png' },
    { code: 'JO', name: 'Jordan', flag: 'https://flagcdn.com/w40/jo.png' },
    { code: 'KZ', name: 'Kazakhstan', flag: 'https://flagcdn.com/w40/kz.png' },
    { code: 'KW', name: 'Kuwait', flag: 'https://flagcdn.com/w40/kw.png' },
    { code: 'KG', name: 'Kyrgyzstan', flag: 'https://flagcdn.com/w40/kg.png' },
    { code: 'LB', name: 'Lebanon', flag: 'https://flagcdn.com/w40/lb.png' },
    { code: 'NP', name: 'Nepal', flag: 'https://flagcdn.com/w40/np.png' },
    { code: 'OM', name: 'Oman', flag: 'https://flagcdn.com/w40/om.png' },
    { code: 'PK', name: 'Pakistan', flag: 'https://flagcdn.com/w40/pk.png' },
    { code: 'QA', name: 'Qatar', flag: 'https://flagcdn.com/w40/qa.png' },
    { code: 'RU', name: 'Russia', flag: 'https://flagcdn.com/w40/ru.png' },
    { code: 'SA', name: 'Saudi Arabia', flag: 'https://flagcdn.com/w40/sa.png' },
    { code: 'LK', name: 'Sri Lanka', flag: 'https://flagcdn.com/w40/lk.png' },
    { code: 'TJ', name: 'Tajikistan', flag: 'https://flagcdn.com/w40/tj.png' },
    { code: 'TR', name: 'Turkey', flag: 'https://flagcdn.com/w40/tr.png' },
    { code: 'AE', name: 'United Arab Emirates', flag: 'https://flagcdn.com/w40/ae.png' },
    { code: 'GB', name: 'United Kingdom', flag: 'https://flagcdn.com/w40/gb.png' },
    { code: 'UZ', name: 'Uzbekistan', flag: 'https://flagcdn.com/w40/uz.png' }
  ];

  const handleCountrySelect = (country) => {
    setSelectedCountry(country);
    setShowDropdown(false);
    onCountrySelect({ ...country, language: selectedLanguage });
  };

  const toggleDropdown = () => {
    if (!showDropdown && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 4,
        left: rect.left - 200
      });
    }
    setShowDropdown(!showDropdown);
  };

  return (
    <div className="country-language-selector">
      <div ref={buttonRef} className="selector-button" onClick={toggleDropdown}>
        <span className="country-code">{selectedCountry.code}</span>
        <span className="separator">|</span>
        <span className="language">{selectedLanguage}</span>
        <span className="arrow">▼</span>
      </div>
      
      {showDropdown && createPortal(
        <div className="selector-dropdown" style={{
          top: `${dropdownPosition.top}px`,
          left: `${dropdownPosition.left}px`
        }}>
          <div className="dropdown-section">
            <div className="section-title">Country</div>
            {countries.map((country) => (
              <div
                key={country.code}
                className={`dropdown-option ${selectedCountry.code === country.code ? 'selected' : ''}`}
                onClick={() => handleCountrySelect(country)}
              >
                <img className="flag" src={country.flag} alt={country.name} />
                <span className="name">{country.name}</span>
                <div className="language-toggle">
                  <span 
                    className={`lang-option ${selectedCountry.code === country.code && selectedLanguage === 'EN' ? 'active' : ''}`}
                    onClick={(e) => { e.stopPropagation(); setSelectedCountry(country); setSelectedLanguage('EN'); setShowDropdown(false); onCountrySelect({ ...country, language: 'EN' }); }}
                  >
                    English
                  </span>
                  <span className="lang-separator">|</span>
                  <span 
                    className={`lang-option ${selectedCountry.code === country.code && selectedLanguage === 'AR' ? 'active' : ''}`}
                    onClick={(e) => { e.stopPropagation(); setSelectedCountry(country); setSelectedLanguage('AR'); setShowDropdown(false); onCountrySelect({ ...country, language: 'AR' }); }}
                  >
                    العربية
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>,
        document.body
      )}
      
      {showDropdown && createPortal(
        <div className="dropdown-overlay" onClick={() => setShowDropdown(false)} />,
        document.body
      )}
    </div>
  );
};

export default CountrySelector;